<input class="form-control form-control-weight"
       [class.is-invalid]="control?.invalid && control?.touched"
       [value]="displayValue"
       (input)="onInput($event)"
       (blur)="onTouchedCallback()"
       [placeholder]="'e.g. 100'"
       type="number"
       step="any"
       required
       style="resize: none"/>
<div class="invalid-feedback" [class]="{ 'invalid-feedback-nowrap': !wrapError() }">
  @if (control?.errors?.min) {
    Gross weight should be more than 0
  } @else if (control?.errors?.max) {
    Gross weight should be less than 1.000.000
  } @else {
    Gross weight is required
  }
</div>
